export default __webpack_public_path__ + "static/media/shopify.09b06755.png";